import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { CartNotEmptyGuard, CheckoutAuthGuard } from '@spartacus/checkout/base/components';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig } from '@spartacus/core';
import { MyAccountPermissionsAuthGuard } from '../../myaccount/guards/myaccount-permissions-auth.guard';
import { CheckoutCartIsValidatedGuard } from '../guards/checkout-cart-validated-guard';
import { CheckoutShippingAddressComponent } from './checkout-shipping-address.component';

@NgModule({
  imports: [CommonModule, I18nModule, BrowserModule, ReactiveFormsModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CheckoutShippingAddress: {
          component: CheckoutShippingAddressComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
          guards: [CheckoutAuthGuard, CartNotEmptyGuard, CheckoutCartIsValidatedGuard, MyAccountPermissionsAuthGuard],
        },
      },
    }),
  ],
  declarations: [CheckoutShippingAddressComponent],
  exports: [CheckoutShippingAddressComponent],
})
export class CheckoutShippingAddressModule {}
